import angular from 'angular';
import uiRouter from 'angular-ui-router';
import videoItemComponent from './videoItem.component';
import AngularYoutube from 'angular-youtube-embed';

let videoItemModule = angular.module('videoItem', [
  uiRouter, AngularYoutube
])
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider
      .state('apps.youtube.show', {
        url: '/:videoId',
        component: 'videoItem',
        resolve: {
          video: (AppsService, $stateParams) => AppsService.videoFeed()
            .then((videos) => _(videos).find((v) => v.id.videoId == $stateParams.videoId)),
          $title: (video) => `Youtube - ${video.snippet.title}`
        }
      });
  })
  .component('videoItem', videoItemComponent)
  .name;

export default videoItemModule;



// WEBPACK FOOTER //
// ./client/app/components/apps/videoItem/videoItem.js